export const blogFeedUrl = 'https://blog.atrera.com/latest.json';
